// Shared Community Forum content — used by the public marketing page
// (/community) and the in-app Resources page (/resources/community) so both
// stay in sync from one source. The forum itself hasn't launched yet; this
// is illustrative preview content.
export const COMMUNITY_CATEGORIES = [
  { name: "General Discussion", threads: 24 },
  { name: "SAM.gov & Opportunities", threads: 41 },
  { name: "AI Drafting Tips", threads: 33 },
  { name: "Compliance & Submission", threads: 19 },
  { name: "Feature Requests", threads: 27 },
];

export const COMMUNITY_THREADS = [
  { title: "Best practices for filtering set-aside opportunities?", category: "SAM.gov & Opportunities", author: "Contributor · IT services (8(a))", replies: 12 },
  { title: "How do you structure your Compliance Matrix for multi-volume RFPs?", category: "Compliance & Submission", author: "Proposal Manager · Cybersecurity", replies: 8 },
  { title: "Tips for getting better AI-generated first drafts", category: "AI Drafting Tips", author: "Contributor · Cloud services", replies: 15 },
  { title: "Anyone using color-team reviews with a 3-person team?", category: "General Discussion", author: "Administrator · Facilities support", replies: 6 },
  { title: "Feature request: bulk NAICS import from a spreadsheet", category: "Feature Requests", author: "KB Manager · Telecom", replies: 9 },
];
